import React from 'react'
import PropTypes from 'prop-types'

import {
  BlockDate,
  BlockText,
  MonthYearContainer,
  StyledButton,
  StyledCTAContainer,
  StyledDateContainer,
  StyledDay,
  StyledEvent,
  StyledHeading,
  StyledMonthYear,
  StyledSeparator,
  UnderLineBlock,
} from './Event.styled'
import {HeadingSizeEnum} from '../Heading/Heading'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import useCtaLink from '../../hooks/useCtaLink'
import format from 'date-fns/format'
import {enUS} from 'date-fns/locale'
import CalendarButton from '../CalendarButton/CalendarButton'

const MAY = 'May'
const TARGET = '_blank'

const Event = ({eventCard, index, isMobile}) => {
  const [ctaUrl, ctaSlug] =
    eventCard.ctaButton && eventCard.ctaButton.url
      ? useCtaLink(eventCard.ctaButton.url)
      : [null, null]

  const getDay = (date) => {
    return format(new Date(date), 'dd', {locale: enUS})
  }

  const getMonth = (date) => {
    const Month = format(new Date(date), 'MMM', {locale: enUS})
    if (Month === MAY) return Month
    else return `${Month}.`
  }

  const getYear = (date) => {
    return format(new Date(date), 'yyyy', {locale: enUS})
  }

  const [startDay, startMonth, startYear] = eventCard.date
    ? [
      getDay(eventCard.date),
      getMonth(eventCard.date),
      getYear(eventCard.date),
    ]
    : [null, null, null]

  const [endDay, endMonth, endYear] = eventCard.endDate
    ? [
      getDay(eventCard.endDate),
      getMonth(eventCard.endDate),
      getYear(eventCard.endDate),
    ]
    : [null, null, null]

  return (
    <StyledEvent key={index + `event`}>
      <BlockDate>
        {eventCard.endDate ? (
          <StyledDateContainer>
            <StyledDay>
              {startDay}-{endDay}
            </StyledDay>
            <StyledSeparator/>
            <UnderLineBlock>
              <MonthYearContainer>
                <StyledMonthYear>{startMonth}</StyledMonthYear>
                <StyledMonthYear>{startYear}</StyledMonthYear>
              </MonthYearContainer>
              <MonthYearContainer>
                <StyledMonthYear>{endMonth}</StyledMonthYear>
                <StyledMonthYear>{endYear}</StyledMonthYear>
              </MonthYearContainer>
            </UnderLineBlock>
          </StyledDateContainer>
        ) : (
          eventCard.date && (
            <StyledDateContainer>
              <StyledDay>{startDay}</StyledDay>
              <StyledSeparator/>
              <StyledMonthYear>{startMonth}</StyledMonthYear>
              <StyledMonthYear>{startYear}</StyledMonthYear>
            </StyledDateContainer>
          )
        )}
      </BlockDate>
      <BlockText>
        <StyledHeading label={eventCard.title} size={HeadingSizeEnum.h3}/>
        <StyledCTAContainer>
          {!isMobile && (
            <CalendarButton
              startDate={eventCard.date}
              endDate={eventCard.endDate}
              title={eventCard.title}
              isMobile={isMobile}
            />
          )}
          <StyledButton
            to={ctaSlug}
            href={ctaUrl}
            target={TARGET}
            variant={ButtonVariantEnum.primary}
          >
            {eventCard.ctaButton.label}
          </StyledButton>
          {isMobile && (
            <CalendarButton
              startDate={eventCard.date}
              endDate={eventCard.endDate}
              title={eventCard.title}
              isMobile={isMobile}
            />
          )}
        </StyledCTAContainer>
      </BlockText>
    </StyledEvent>
  )
}

Event.propTypes = {
  index: PropTypes.number,
  eventCard: PropTypes.object.isRequired,
}

export default Event
